import React from 'react';

// Awning-specific quote form fields. Relies on the surrounding <form>'s name
// attributes for HTML form submission; `colour` optionally pre-fills the fabric
// field when the visitor arrived from a specific colourway on /colours.
export default function AwningFields({ colour = '' }) {
  return (
    <>
      <div className="asg-form-row">
        <div className="asg-form-group">
          <label className="asg-form-label">Which model?</label>
          <select className="asg-select" name="model" defaultValue="">
            <option value="" disabled>Select</option>
            <option value="AW01 Full Cassette Awning">AW01 Full Cassette Awning</option>
            <option value="B05 Traditional Scalloped">B05 Traditional Scalloped</option>
            <option value="B06 Premium Open-Arm">B06 Premium Open-Arm</option>
            <option value="A09 Long-Projection">A09 Long-Projection</option>
            <option value="K3 Heritage Mediterranean">K3 Heritage Mediterranean</option>
            <option value="Not sure yet">Not sure yet</option>
          </select>
        </div>
        <div className="asg-form-group">
          <label className="asg-form-label">Approx. dimensions (W × P)</label>
          <input type="text" className="asg-input" name="total_size" placeholder="e.g. 4m × 3m" />
        </div>
      </div>
      <div className="asg-form-group">
        <label className="asg-form-label">Fabric colour</label>
        <input
          type="text"
          className="asg-input"
          name="fabric_colour"
          defaultValue={colour}
          placeholder="e.g. AW-SC-2170 Charcoal Grey, or leave blank"
        />
      </div>
      <div className="asg-form-group">
        <label className="asg-form-label">Mounting</label>
        <div className="asg-checkbox-row">
          <label className="asg-checkbox-label"><input type="radio" name="ceiling_type" value="Wall mount" /> Wall mount</label>
          <label className="asg-checkbox-label"><input type="radio" name="ceiling_type" value="Ceiling/soffit mount" /> Ceiling/soffit</label>
          <label className="asg-checkbox-label"><input type="radio" name="ceiling_type" value="Not sure" /> Not sure</label>
        </div>
      </div>
      <div className="asg-form-group">
        <label className="asg-form-label">Optional extras</label>
        <div className="asg-checkbox-row">
          <label className="asg-checkbox-label"><input type="checkbox" name="attachments[]" value="LED Lighting" /> LED Lighting</label>
          <label className="asg-checkbox-label"><input type="checkbox" name="attachments[]" value="Wind sensor" /> Wind sensor</label>
          <label className="asg-checkbox-label"><input type="checkbox" name="attachments[]" value="Motorised" /> Motorised</label>
        </div>
      </div>
    </>
  );
}
